import PropTypes from 'prop-types';
import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux';

import timestamps from '~/services/timestamps'

import { Icon } from '~/components'


class FeaturedVertical extends React.Component {
    static propTypes = {
		user: PropTypes.object.isRequired,
		bookmark: PropTypes.oneOfType([
			PropTypes.func, 
			PropTypes.bool
		]).isRequired,
		bookmarks: PropTypes.array.isRequired,
		bookmarked: PropTypes.string,
		comment_count: PropTypes.number.isRequired,
		date: PropTypes.string.isRequired,
		excerpt: PropTypes.string,
		flare: PropTypes.oneOfType([
			PropTypes.func,
			PropTypes.bool
		]).isRequired,
		flares: PropTypes.array.isRequired,
		flared: PropTypes.string,
		images: PropTypes.object.isRequired,
		ID: PropTypes.number,
		interests: PropTypes.array,
		read_time: PropTypes.number.isRequired,
		slug: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
	};

    state = {
        bookmarked: !!this.props.bookmarked,
        flared: !!this.props.flared
    };

    bookmark = () => {
		if(!this.props.bookmark) return false;
		this.props.bookmark(this.props.ID)
		this.setState({
			bookmarked: !this.state.bookmarked
		})
	};

    flare = () => {
		if(!this.props.flare) return false;
		this.props.flare(this.props.ID)
		this.setState({
			flared: !this.state.flared
		})
	};

    link = () => {
		this.props.history.push(this.props.link)
	};

    render() {

		var article = this.props,
			bookmarked = this.state.bookmarked,
			banner = article.images.banner,
			cropPosition = banner.split('crop_position=')[1],
			bannerStyle = {
				backgroundImage: 'url(' + article.images.banner + ')',
				backgroundPositionY: cropPosition
			};

		return (
			<div className="vertical-article-holder">
				<header className="bg-white p10">
					<p className="mtop0 mbot15"><strong>{this.props.sectionTitle}</strong></p>	
        			<Link to={article.link} state={{article: article}}>
	            		<h3 className="mtop0 mbot15">{article.title}</h3>
        			</Link>
					<p className="small details text-dark-gray">
						{ article.interests.length > 0 &&
							article.interests.slice(0,3).map(interest => {
								return <Link to={interest.link} key={article.uniqueID+'-featured-vertical-'+interest.ID}>
									<span className="mright10" key={article.ID+'-tags-'+interest.ID}>{interest.tag}</span>
								</Link>
							})
						}
					</p>
				</header>
				<div className="fill-image">
					<div className="background-fill clickable" style={bannerStyle} onClick={this.link}></div>
					{this.props.bookmark &&
						<div className="hover-icons">
							<span className={"clickable hover-icon " + (this.state.bookmarked ? 'bookmarked' : '')} onClick={this.bookmark}>
								<Icon icon="bookmarks" className={this.state.bookmarked ? 'text-light-success' : 'text-mid-gray'} />
							</span>
						</div>
					}
				</div>
            	<footer className="bg-white p10 narrow-gutter">
            		<div className="row">
	            		<div className="col-md-2 col-xs-3">
	            			<Link to={article.user.link}>
								<div className="profile-image" style={{backgroundImage: 'url(' + article.user.profile_picture + ')'}}></div>
							</Link>
            			</div>
	            		<div className="col-md-7 col-xs-6">
							<p className="">{article.user.first + ' ' + article.user.last}</p>
							<p className="small">{'Posted ' + timestamps.timeSince(article.date, true)}</p>
							<p className="small">{article.read_time + ' min read'}</p>
            			</div>
	            		<div className="col-xs-3">
                            { this.props.sessionsAllowed &&
								<React.Fragment>
									<p className="small details text-mid-gray"><Icon icon={'comments'} className={'text-dark-gray'} /> {article.comment_count}</p>
									<p className="small details text-mid-gray"><Icon icon={'bookmarks'} className={'text-dark-gray'} /> {article.bookmarks.length}</p>
									<p className="small details text-mid-gray"><Icon icon={'flares'} className={'text-dark-gray'} /> {article.flares.length}</p>
								</React.Fragment>
                            }
	            		</div>
            		</div>
            	</footer>
			</div>
		)
		
	}
}

const mapStatetoProps = state => ({
    sessionsAllowed: state.session.sessionsAllowed
})

export default connect(
    mapStatetoProps
)( withRouter(FeaturedVertical) );




// WEBPACK FOOTER //
// ./src/js/views/Discover/scenes/Unfiltered/components/FeaturedVertical.jsx